import { type ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { DonateBanner } from '@/components/DonateBanner'
import { useRecentTools } from '@/hooks/useRecentTools'
import { tools } from '@/pages/Tools'

interface PageWrapperProps {
  children: ReactNode
}

// Set of tool hrefs for quick lookup
const toolHrefs = new Set(tools.map(t => t.href))

export function PageWrapper({ children }: PageWrapperProps) {
  const location = useLocation()
  const { trackTool } = useRecentTools()

  useEffect(() => {
    if (toolHrefs.has(location.pathname)) {
      trackTool(location.pathname)
    }
  }, [location.pathname, trackTool])

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <div className="md:ml-64">
        <Header />
        <DonateBanner />
        <main className="p-6 md:p-8 max-w-7xl mx-auto">{children}</main>
      </div>
    </div>
  )
}
